
import AnimatedSection from '../../../components/base/AnimatedSection';

const WA_RESERVAR =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function ParaVosSi() {
  const items = [
    {
      icon: "ri-building-line",
      text: "Sos dueño de pyme y querés ahorrar tiempo en tareas repetidas.",
    },
    {
      icon: "ri-briefcase-line",
      text: "Sos profesional y necesitás producir mejor, más rápido.",
    },
    {
      icon: "ri-rocket-line",
      text: "Querés aprender a vender mejor con la IA.",
    },
    {
      icon: "ri-team-line",
      text: "Liderás un equipo y querés un método simple para usar IA sin caos.",
    },
  ];

  return (
    <section className="py-20 bg-teal-500">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center">
              Esto es para vos si
            </h2>
          </AnimatedSection>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {items.map((item, index) => (
              <AnimatedSection key={item.icon} animation="fadeUp" delay={index * 100}>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 h-full">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center">
                      <i className={`${item.icon} text-3xl text-white`} />
                    </div>
                    <p className="text-white text-lg">{item.text}</p>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>

          <AnimatedSection animation="fadeUp" delay={100}>
            <div className="bg-white rounded-xl p-8 mb-8">
              <p className="text-gray-900 text-lg mb-2">No hace falta ser técnico.</p>
              <p className="text-gray-900 text-lg font-semibold">
                Sí hace falta venir con ganas de practicar.
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection animation="scaleUp" delay={200}>
            <div className="text-center">
              <a
                href={WA_RESERVAR}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold text-lg hover:bg-gray-100 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-white/50"
              >
                Reservar por WhatsApp
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
